/* tslint:disable */
/* eslint-disable */
/**
 * Oil refinery process modeling system
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {mapValues} from '../runtime';
import type {RJSFSchemas} from './RJSFSchemas';
import {RJSFSchemasFromJSON, RJSFSchemasFromJSONTyped, RJSFSchemasToJSON} from './RJSFSchemas';

/**
 *
 * @export
 * @interface SetElementAdditionalTabsResult
 */
export interface SetElementAdditionalTabsResult {
  /**
   *
   * @type {boolean}
   * @memberof SetElementAdditionalTabsResult
   */
  treeChanged?: boolean;
  /**
   *
   * @type {{ [key: string]: RJSFSchemas; }}
   * @memberof SetElementAdditionalTabsResult
   */
  schemas: {[key: string]: RJSFSchemas};
}

/**
 * Check if a given object implements the SetElementAdditionalTabsResult interface.
 */
export function instanceOfSetElementAdditionalTabsResult(
  value: object
): value is SetElementAdditionalTabsResult {
  if (!('schemas' in value) || value['schemas'] === undefined) return false;
  return true;
}

export function SetElementAdditionalTabsResultFromJSON(json: any): SetElementAdditionalTabsResult {
  return SetElementAdditionalTabsResultFromJSONTyped(json, false);
}

export function SetElementAdditionalTabsResultFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): SetElementAdditionalTabsResult {
  if (json == null) {
    return json;
  }
  return {
    treeChanged: json['tree_changed'] == null ? undefined : json['tree_changed'],
    schemas: mapValues(json['schemas'], RJSFSchemasFromJSON)
  };
}

export function SetElementAdditionalTabsResultToJSON(
  value?: SetElementAdditionalTabsResult | null
): any {
  if (value == null) {
    return value;
  }
  return {
    tree_changed: value['treeChanged'],
    schemas: mapValues(value['schemas'], RJSFSchemasToJSON)
  };
}
